jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
	hintbox: {
		addClassNoDisplay: function ($element) {
			$element.addClass('noDisplay');
			$element.removeAttr('role');
			$element.attr('aria-hidden', 'true');
			$element.attr('inert', 'true');
		},

		removeClassNoDisplay: function ($element) {
			$element.removeClass('noDisplay');
			$element.attr('role', 'alert');
			$element.attr('aria-hidden', 'false');
			$element.removeAttr('inert');
		},

		addClassIsVisible: function ($element) {
			$element.addClass('is-visible');
			$element.attr('role', 'alert');
			$element.attr('aria-hidden', 'false');
			$element.removeAttr('inert');
		},

		removeClassIsVisible: function ($element) {
			$element.removeClass('is-visible');
			$element.removeAttr('role');
			$element.attr('aria-hidden', 'true');
			$element.attr('inert', 'true');
		},
	},
});
